import script from "./hero.vue?vue&type=script&setup=true&lang=js"
export * from "./hero.vue?vue&type=script&setup=true&lang=js"

import "./hero.vue?vue&type=style&index=0&id=3172f49a&lang=scss"

export default script